import React, { Component } from 'react'
import scrollIntoView from 'scroll-into-view'

import { connect } from 'react-redux'
//import messageActions from '../../../store/actions/messageActions'

import socket from '../../../../helpers/socket'
import helpers from '../../../../helpers/helpers'

import Message from './message/message'

import './modalWindowBody.css'
import FaEye from 'react-icons/lib/fa/eye'

class ModalWindowBody extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  el = null;

  state = {
    scrollPosition: 0
  }

  paneDidMount = (node) => {
    if (node) {
      node.addEventListener('scroll', this.handleScroll);
    }
  };

  handleScroll(e) {
    //console.log('the scroll things', e)
    const maxPos = parseInt(e.target.scrollHeight, 0) - 203;
    let pos = parseInt(e.target.scrollTop, 0);
    this.setState({ scrollPosition: pos * 191 / maxPos });
  };

  scrollToBottom() {
    //if (this.el !== null) this.el.scrollIntoView(true, {behaviour: 'smooth'});
    if (this.el !== null) {
      scrollIntoView(this.el, {
        time: 250,
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //scroll to bottom only if new message arrives for current window:
    const chat = this.props.chats.filter(el => el.contactId === this.props.contact.id);
    const messages = chat.length === 0 ? [] : chat[0].messages;

    const prevChat = prevProps.chats.filter(el => el.contactId === this.props.contact.id);
    const prevMessages = prevChat.length === 0 ? [] : prevChat[0].messages;


    if (messages.length !== prevMessages.length)
      this.scrollToBottom()
  }

  componentDidMount() {
    this.scrollToBottom()
    //find related chat and extract latest message timestamp:
    const chatsFiltered = this.props.chats
      .filter(el => {
        return el.contactId === this.props.contact.id
      })

    let latestTime = chatsFiltered.length === 0 ?
      0 : chatsFiltered[0].messages.length === 0 ?
        0 : chatsFiltered[0].messages[chatsFiltered[0].messages.length - 1].time;

    socket.emit('messagesRequest', {
      owner: this.props.contact.id,
      latestTime: latestTime
    })
  }

  render() {
    const scrollPosition = this.state.scrollPosition + "px";
    const chat = this.props.chats.filter(el => el.contactId === this.props.contact.id);
    const messages = chat.length === 0 ? [] : chat[0].messages;
    const seen = this.props.seen
      .filter(el => el === this.props.contact.id).length > 0 ?
      "modalWindowBodyShow" : "modalWindowBodyHide"

    return (
      <div className="modalWindowBody">
        <div className="modalWindowScrollbarContainer">
          <div className="modalWindowScrollbar">
            <div className="modalWindowScrollbarButton" style={{ marginTop: scrollPosition }}></div>
          </div>
        </div>
        <div ref={this.paneDidMount} className="modalWindowContent">
          <div>{
            messages.map((el, i) => {
              return <Message key={i}
                contact={this.props.contact}
                sender={el.owner}
                message={el.message}
                type={el.type}
                el={el}
                time={helpers.timeSince(el.time)}
              />
            })
          }

          </div>
          <br />
          <div ref={el => {
            this.el = el;
          }} />
        </div>
        <div className="seenContainer">
          <div>
            <span className={seen}><FaEye /></span>
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    myId: state.auth.currentUser.id,
    chats: state.messageReducer.chats,
    contactModals: state.contactReducer.contactModals,
    seen: state.messageReducer.seen
  }
}

export default connect(mapStateToProps)(ModalWindowBody);


// WEBPACK FOOTER //
// ./src/common/chat/modalWindow/modalWindowBody/modalWindowBody.js